import Config from '@config';
import { initializeMeasurementRangesApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const measurementRanges = initializeMeasurementRangesApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  measurementRangesApi,
  useGetMeasurementRangesQuery,
  useGetMeasurementRangeByIdQuery,
} = measurementRanges;
